export default __webpack_public_path__ + "static/media/MadeleineCTestimonial.3541a862.png";